import { TableCell } from "@mui/material";
import {
  IAdditional,
  IAdditionalHeaderProps,
} from "../../TableTemplate/tableTemplate";
import { useState } from "react";
import Button from "../../../Components/Button";
import Modal from "../../../Components/Modal/Modal";
import FullScreenLoading from "../../../Components/Loading/FullScreenLoading";
import { IAllowedTradesTableReport } from "../../../Interfaces/deltaHedgeExe";
import LogsTable from "./LogsTable";

const AdditionalHeader = ({}: IAdditionalHeaderProps) => {
  return (
    <>
      <TableCell />
    </>
  );
};

enum ModalMode {
  Logs,
  Closed,
}

const AdditionalCol: React.FC<{
  row: IAllowedTradesTableReport;
  onAction: () => void;
}> = ({ row, onAction }) => {
  const [modalMode, setModalMode] = useState(ModalMode.Closed);

  const getModalUI = () => {
    switch (modalMode) {
      case ModalMode.Logs:
        return <LogsTable id={row.id} />;

      case ModalMode.Closed:
        return <></>;
    }
  };

  return (
    <>
      <TableCell>
        {modalMode !== ModalMode.Closed ? (
          <Modal title="لاگ"
            UI={getModalUI()}
            onClose={() => setModalMode(ModalMode.Closed)}
          />
        ) : (
          <></>
        )}
        <div className="w-16">
          <Button
            text="لاگ"
            variant="contained"
            className="table-btn"
            onClick={() => setModalMode(ModalMode.Logs)}
          />
        </div>
      </TableCell>
    </>
  );
};

export const Additional: IAdditional<IAllowedTradesTableReport> = {
  getHeader: AdditionalHeader,
  getRow: AdditionalCol,
};
